// vue PC分页
export default {
  data: function () {
    return {
      list: [],
      total: 0,
      isLoading: false, // 拉取状态
      isNodata: false, // 是否无数据
      listQuery: {
        page: 1,
        limit: 20,
        order: 'id', // 默认排序方式,
        sort: 'DESC'
      },
      queryUrlBase: '' // '/dpc/' //查询接口前缀地址
    }
  },
  computed: {},
  methods: {
    LoadData () {
      this.qyloading = true // 页面区域loading
      this.isLoading = true
      this.api.Query(this.listQuery).then(response => {
        if (this.afterLoadData) {
          response.items = this.afterLoadData(response.items)
        }
        this.list = response.items
        this.total = response.total
        this.isLoading = false
        this.qyloading = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/vue_list.js